var map = {
	"./banner-new.png": 1063,
	"./card-bg-1.png": 1128,
	"./card-bg-2.png": 1129,
	"./card-bg-3-old.png": 1130,
	"./card-bg-3.png": 1131,
	"./card-bg-small.png": 1132,
	"./coupon-icon.png": 1133,
	"./genshin/button-bg.png": 1134,
	"./genshin/coupon.png": 1030,
	"./genshin/coupon_bg.png": 1135,
	"./genshin/coupon_bg_popup_1.png": 1136,
	"./genshin/coupon_bg_popup_2.png": 1137,
	"./genshin/gift_bg.png": 1138,
	"./genshin/gift_bg_popup_1.png": 1139,
	"./genshin/gift_bg_popup_2.png": 1140,
	"./genshin/kGold.png": 1029,
	"./genshin/popup-bg-1.png": 1141,
	"./genshin/popup-bg-2.png": 1142,
	"./genshin/popup-bg-invited.png": 1143,
	"./genshin/popup-bg_GT.png": 1144,
	"./genshin/popup-btn-guest-login.png": 1145,
	"./genshin/popup-btn-guest.png": 1146,
	"./genshin/popup-btn-owner.png": 1147,
	"./icon/award__coupon.png": 1009,
	"./icon/coupon-new.png": 1022,
	"./icon/coupon.png": 1008,
	"./icon/facebook.png": 1060,
	"./icon/gift.png": 1040,
	"./icon/google.png": 1061,
	"./icon/kgold-new.png": 1023,
	"./icon/kgold.png": 999,
	"./icon/score-icon.png": 1015,
	"./icon/uc-new.png": 1024,
	"./mlbb-banner.png": 1082,
	"./mlbb.png": 1148,
	"./mobile-legends/award.png": 1149,
	"./mobile-legends/button-bg.png": 1150,
	"./mobile-legends/coupon-icon.png": 1151,
	"./mobile-legends/coupon_bg.png": 1071,
	"./mobile-legends/coupon_bg_popup_1.png": 1152,
	"./mobile-legends/coupon_bg_popup_2.png": 1153,
	"./mobile-legends/gift_bg.png": 1072,
	"./mobile-legends/gift_bg_popup_1.png": 1154,
	"./mobile-legends/gift_bg_popup_2.png": 1155,
	"./mobile-legends/payment-award__sku.png": 1156,
	"./mobile-legends/popover-coupon-icon.png": 1028,
	"./mobile-legends/popup-bg-1.png": 1157,
	"./mobile-legends/popup-bg-2.png": 1158,
	"./mobile-legends/popup-bg-invited.png": 1159,
	"./mobile-legends/popup-bg_GT.png": 1160,
	"./mobile-legends/popup-btn-guest.png": 1161,
	"./mobile-legends/popup-btn-owner.png": 1162,
	"./mobile-legends/register-award__sku.png": 1163,
	"./mobile-legends/score-icon.png": 1064,
	"./mobile-legends/sku-icon.png": 1164,
	"./parachute.png": 1073,
	"./pubgm/award-bg.png": 1165,
	"./pubgm/award-icon-1.png": 1166,
	"./pubgm/award__sku.png": 1167,
	"./pubgm/big-sku-icon.png": 1168,
	"./pubgm/button-bg.png": 1169,
	"./pubgm/coupon-icon.png": 1170,
	"./pubgm/coupon-sharee-bg.png": 1171,
	"./pubgm/coupon-sharer-bg.png": 1172,
	"./pubgm/coupon_bg.png": 1173,
	"./pubgm/coupon_bg_popup_1.png": 1174,
	"./pubgm/coupon_bg_popup_2.png": 1175,
	"./pubgm/gift_bg.png": 1176,
	"./pubgm/gift_bg_popup_1.png": 1177,
	"./pubgm/gift_bg_popup_2.png": 1178,
	"./pubgm/login-btn-new.png": 1179,
	"./pubgm/popover-coupon-icon.png": 1005,
	"./pubgm/popup-bg-1.png": 1180,
	"./pubgm/popup-bg-2.png": 1181,
	"./pubgm/popup-bg-bottom.png": 1182,
	"./pubgm/popup-bg-invited.png": 1183,
	"./pubgm/popup-bg_GT.png": 1184,
	"./pubgm/popup-btn-guest.png": 1185,
	"./pubgm/popup-btn-owner.png": 1186,
	"./pubgm/popup-top-icon.png": 1187,
	"./pubgm/pubgm-bg.png": 1188,
	"./pubgm/pubgm-personage.png": 1031,
	"./pubgm/score-icon.png": 1065,
	"./pubgm/sku-icon.png": 1189,
	"./pubgm/small-coupon-icon.png": 1190,
	"./pubgm/small-sku-icon.png": 1191,
	"./pubgm/toplupe-pubgm.png": 1032,
	"./score-bg.png": 1192,
	"./submit-bg.png": 1193,
	"./tip-bg.png": 1194,
	"./user-bg.png": 1062
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1582;